import { PureComponent } from 'react';
import { throttle } from 'lodash-es';

import Icon from 'components/Icon';
import WithScroll from 'hocs/WithScroll';

class BackToTop extends PureComponent {
  constructor(props) {
    super(props);

    this.setScreenHeight();
    this.state = { isVisible: false };

    this.throttledToggleVisibility = throttle(this.toggleVisibility, 250);
    this.throttledSetScreenHeight = throttle(this.setScreenHeight, 250);
  }

  componentDidMount() {
    this.props.scroll.addListener('scroll', this.throttledToggleVisibility);

    window.addEventListener('resize', this.throttledSetScreenHeight);
  }

  componentWillUnmount() {
    this.props.scroll.removeListener('scroll', this.throttledToggleVisibility);

    window.removeEventListener('resize', this.throttledSetScreenHeight);
  }

  setScreenHeight = () => {
    this.screenHeight = document.body.offsetHeight;
  };

  toggleVisibility = top => {
    const showCondition = top >= this.screenHeight;
    const { isVisible } = this.state;

    isVisible !== showCondition && this.setState({ isVisible: showCondition });
  };

  handleBackToTopClick = () => {
    this.props.scroll.triggerScrolling(0, true);
  };

  render() {
    return (
      <button
        className={cx('btn', '_move-to-top', {
          visible: this.state.isVisible,
        })}
        onClick={this.handleBackToTopClick}
      >
        <Icon icon="arrow-up" className="icon_primary" />
        <Icon icon="arrow-up" className="icon_secondary" />
      </button>
    );
  }
}

export default WithScroll(BackToTop);
